import React from "react";

export default function FooterColumn({ title, children, className = "" }) {
  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      {title && (
        <h4 className="text-xs font-bold uppercase tracking-wider text-gray-900 font-display">
          {title}
        </h4>
      )}
      <div className="flex flex-col gap-3">
        {children}
      </div>
    </div>
  );
}
